// Vendor libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Interfaces
import { BackgroundJobsInProgressResponse } from '../interfaces/background-job.interface';

// Services
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class BackgroundJobService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    fetchJobsInProgress(): Observable<BackgroundJobsInProgressResponse> {
        const url = this.urlsService.BACKGROUND_JOBS.JOBS_IN_PROGRESS;
        return this.ajaxService.getDataObserveBody<BackgroundJobsInProgressResponse>(url);
    }
}
